import React, { useState } from 'react'
import './nav.css'
import { AiOutlineHome, AiOutlineUser } from 'react-icons/ai'
import { MdWorkOutline } from "react-icons/md";
import { BiBook, BiMessageSquareDetail } from "react-icons/bi";
import { RiServiceLine } from "react-icons/ri";

const LINKS = [
  { href: "#home", label: "Home", Icon: AiOutlineHome },
  { href: "#about", label: "About", Icon: AiOutlineUser },
  { href: "#experiences", label: "Experience", Icon: MdWorkOutline },
  { href: "#skills", label: "Skills", Icon: BiBook },
  { href: "#portfolio", label: "Portfolio", Icon: RiServiceLine },
  { href: "#contact", label: "Contact", Icon: BiMessageSquareDetail },
];

const Nav = () => {
  const [activeNav, setActiveNav] = useState('#home');

  return (
    <nav>
      {LINKS.map(({ href, label, Icon }) => (
        <a
          key={href}
          href={href}
          aria-label={label}
          title={label}
          onClick={() => setActiveNav(href)}
          className={activeNav === href ? "active" : ""}
        >
          <Icon />
        </a>
      ))}
    </nav>
  );
}

export default Nav
